// eslint-disable-next-line no-use-before-define
import React, { Suspense, useEffect } from 'react';
import { LoadingAnimation } from '../../elements/LoadingAnimation/LoadingAnimation';
import { setPageTitle } from '../../utilities/PageTitleUtil/PageTitleUtil';

const LoadedAdvancedSearchPagePage = React.lazy(() =>
  import('./AdvancedSearchPage').then(({ AdvancedSearchPage }) => ({ default: AdvancedSearchPage }))
);

export const LoadableAdvancedSearchPage = () => {
  useEffect(() => setPageTitle('Advanced Search'), []);

  return (
    <Suspense fallback={<LoadingAnimation />}>
      <LoadedAdvancedSearchPagePage />
    </Suspense>
  );
};
